import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import { InsuredPersonResponse } from '../../../../store/details/insured-person/model';
import { StaticInformation } from '../../../custom/static-information';
import { connect } from 'react-redux';
import styles from './insured-person.module.css';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import { Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { getTypeCodesForLanguage } from 'src/store/utils/typecodes/typecode-translations';
import { Dispatch } from 'redux';
import { updateLanguageInsuredPerson } from 'src/store/details/insured-person/actions';

interface PropsFromState {
  readonly insuredPerson: InsuredPersonResponse;
  readonly blocked: boolean;
  readonly currentLanguage: string;
  readonly instructionId: number;
}

interface PropsFromDispatch {
  readonly updateLanguageInsuredPerson: typeof updateLanguageInsuredPerson;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class InsuredPerson extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    let mobile = `${this.props.insuredPerson.mobile}`;
    let telephone = `${this.props.insuredPerson.telephone}`;
    let telephoneWork = `${this.props.insuredPerson.telephoneWork}`;
    if (mobile !== `null` && mobile !== `?` && mobile !== `undefined`) {
      mobile = mobile.replace(' ', '/').replace(/[/]+/g, '/').replace(/\s/g, '');
    } else {
      mobile = '';
    }
    if (telephone !== `null` && telephone !== `?` && telephone !== `undefined`) {
      telephone = telephone.replace(' ', '/').replace(/[/]+/g, '/').replace(/\s/g, '');
    } else {
      telephone = '';
    }
    if (telephoneWork !== `null` && telephoneWork !== `?` && telephoneWork !== `undefined`) {
      telephoneWork = telephoneWork.replace(' ', '/').replace(/[/]+/g, '/').replace(/\s/g, '');
    } else {
      telephoneWork = '';
    }
    return (
      <div className={styles.container}>
        <div className={styles.static}>
          <div className={styles.staticContent}>
            <StaticInformation
              translation='details.person'
              headerText='details.insuredPerson.header'
              information={{
                'firstName': this.props.insuredPerson.firstName,
                'lastName': this.props.insuredPerson.lastName,
                'companyName': this.props.insuredPerson.companyName,
                'occupancy': this.props.insuredPerson.occupancy,
                'companyNumber': this.props.insuredPerson.companyNumber,
                'clientType': this.props.insuredPerson.clientType,
                'street': this.props.insuredPerson.street,
                'buildingNumber': this.props.insuredPerson.buildingNumber,
                'busNumber': this.props.insuredPerson.busNumber,
                'zipCode': this.props.insuredPerson.zipCode,
                'city': this.props.insuredPerson.city,
                'country': this.props.insuredPerson.country,
                'bankAccount': this.props.insuredPerson.accountNumber,
                'iban': this.props.insuredPerson.iban,
                'bic': this.props.insuredPerson.bic,
                'telephone': telephone,
                'telephoneWork': telephoneWork,
                'mobile': mobile,
                'fax': this.props.insuredPerson.fax,
                'email': this.props.insuredPerson.email,
              }} />
              <div className={styles.containerbelow}>
                <div className={styles.informationKeys}>
                  <div className={styles.keyContainer}>
                    <span className={styles.key}>{this.localization.get('details.person.language')}:</span>
                  </div>
                  <div className={styles.valueContainer}>
                    <Select
                      value={this.props.insuredPerson.languageTC}
                      onChange={(event: SelectChangeEvent<string>) => {
                        this.props.updateLanguageInsuredPerson(this.props.instructionId, event.target.value);
                      }}
                      disabled={this.props.blocked}>
                      {getTypeCodesForLanguage(this.props.insuredPerson.languageTypeList, this.props.currentLanguage).map(o =>
                        <MenuItem
                          value={o.typeCodeValue}
                          key={o.typeCodeValue}>{o.translation}
                        </MenuItem>)}
                    </Select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsInsuredPerson }, caseState: { selectedCase}, shared }: ApplicationState): PropsFromState => ({
  insuredPerson: detailsInsuredPerson,
  blocked: selectedCase.blocked,
  currentLanguage: shared.currentLanguage,
  instructionId: selectedCase.instructionId,
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  updateLanguageInsuredPerson: (instructionId: number, languageTC: string) => dispatch(updateLanguageInsuredPerson(instructionId, languageTC)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InsuredPerson);
